import api from '@/plugins/api'
import { forceLogout } from '@/plugins/main'
export default {
  methods: {
    ...api,
    async forceLogout(message) {
      await forceLogout({ code: '', message: message })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apiMixin.js